/**
 * Users Module
 *
 * This module provides user management functionality including:
 * - User management (Korisnici) - Create, update, archive users
 * - Role management (Uloge) - Assign roles to users
 * - Permission management (Permisije) - Assign permissions to users/roles
 * 
 * Access:
 * - SystemAdmin: Full access to all features
 * - UserAdmin: User management only
 * 
 * Integration:
 * - Users created here are synced to Keycloak for authentication
 * - Users are also created in Fleet module as FleetUser entities
 */

import type { ModuleDefinition } from '@core/router/types';
import { usersRoutes } from './routes';
import { usersNavigation, usersModuleInfo } from './navigation';

/**
 * Users Module Definition
 *
 * Registers the users module with the application.
 */
export const usersModule: ModuleDefinition = {
  name: 'korisnici',
  basePath: '/korisnici',
  routes: usersRoutes,
  navigation: usersNavigation,
  moduleInfo: usersModuleInfo,
};

export default usersModule;

